import { Views } from './routes/Views';
import { AuthProvider } from './contexts/authContext/AuthProvider';
import Keycloak from 'keycloak-js';

interface AppProps {
	readonly keycloak: Keycloak;
}

function App({ keycloak }: AppProps) {
	return (
		<AuthProvider keycloak={keycloak}>
			<Views />
		</AuthProvider>
	);
}

export default App;
